import { ChildModel, ModelBase } from 'store/model-base';
import { RelatedStatementTransaction } from './related-statement-transaction';

export class RelatedStatementTransactionCollection extends ModelBase {
    public static storeName: string = 'relatedStatementTransactionCollection';
    public static idAttribute: string = 'statementKey';

    public statementId: string;
    public relatedStatementTransaction: RelatedStatementTransaction[];

    public static create<T extends ModelBase>(data: ApiResponse): T {
        data.relatedStatementTransaction = data.relatedStatementTransaction || [];

        return super.create<T>(data);
    }

    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'relatedStatementTransaction',
            model: RelatedStatementTransaction
        }];
    }
}
